import script from "./CadastroSubTipoAtend.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroSubTipoAtend.vue?vue&type=script&setup=true&lang=js"

import "./CadastroSubTipoAtend.vue?vue&type=style&index=0&id=12c6c5ce&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c6c5ce"]])

export default __exports__